// src/app/services/welcome.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WelcomeService {
  private readonly KEY = 'hasSeenWelcome';
  hasSeen(): boolean {
    return localStorage.getItem(this.KEY) === 'true';
  }
  markSeen(): void {
    localStorage.setItem(this.KEY, 'true');
  }
  markNotSeen(): void {
    localStorage.setItem(this.KEY, 'false');
  }
}
